import { AiFillSave } from "react-icons/ai";
import { Field, Formik } from "formik"
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import * as Yup from 'yup';
import Post from "../../../api/Post";
import { PARTNER_ADD } from "../../../api/Routes";
import { useState } from "react";

function AddPartner({setLoading, companyOpt, setTextoLoading, accesToken, setItems,initialValues, items,setInitialValues}){
    
    console.log(initialValues)
    
    const shemaValidate = Yup.object().shape({
        name:Yup.string().required('Campo Requerido'),
        company: Yup.string().required('Campo Requerido')
    });

    return (
        <>
            <Row>
                <Col>
                    <Formik 
                        initialValues={initialValues}
                        validationSchema={shemaValidate}
                        onSubmit={(values, { setSubmitting, setFieldValue, resetForm }) => { 
                            let d = Object.assign({}, values)
                            d['company'] = {id: values.company}

                            setLoading(true)
                            setTextoLoading("Procesando información")
                            
                            Post({url: PARTNER_ADD, data: d, header:true, access_token:accesToken})
                            .then((response) => {
                                console.log(response)
                                let arr = [...items]
                                let findIndex = arr.findIndex(el=>el.id===response.data.id)
                                if(findIndex >= 0){
                                    arr[findIndex].name = response.data.name
                                    arr[findIndex].company = {
                                        id: response.data.company.id,
                                        name: response.data.company.name
                                    }
                                    setItems(arr)
                                }else{
                                    setItems(prev=>[...prev, response.data])
                                }
                                setInitialValues({
                                    id: "",
                                    name: "",
                                    company: "",
                                    active: true
                                })                 
                                setLoading(false)
                                resetForm()
                            })                
                            .catch((error) => {
                                console.log("Error encontrado", error)
                                setLoading(false)
                            })     
                        }}
                        enableReinitialize={true}
                    >{({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        resetForm
                    }) => (
                        <Form onSubmit={handleSubmit}  className='mt-3'>
                            <Card className="shadow-1 formSection">
                                <Card.Body>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <h4><span className="subtitulo">Añadir nuevo cliente corporativo</span></h4>
                                        </Col>
                                    </Row>
                                    <div className="body">
                                        <Row>
                                            <Col xs="12" md="12">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Nombre</Form.Label>
                                                    <Field 
                                                        type="text"
                                                        className={`form-control input-form ${errors.name && 'error'}`}
                                                        name="name"
                                                    />
                                                    { errors.name && <div className="invalid-feedback d-block">{errors.name}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="12">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Compañía</Form.Label>
                                                    <Field 
                                                        as="select"
                                                        className={`form-control input-form ${errors.company && 'error'}`}
                                                        name="company"
                                                    >
                                                        <option value="">Seleccionar</option>
                                                        {
                                                            companyOpt.map((item, i)=>(
                                                                <option key={i} value={item.id}>{item.name}</option>
                                                            ))
                                                        }
                                                    </Field>
                                                    { errors.company && <div className="invalid-feedback d-block">{errors.company}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="12">
                                                <Button type="submit" variant="link" className='btn-add float-right'>
                                                    <AiFillSave className="icon-save"/>
                                                </Button>{''}
                                            </Col>
                                        </Row>
                                    </div>   
                                </Card.Body>
                            </Card>
                        </Form>
                    )}</Formik>
                </Col>
            </Row>
        </>
    )
}

export default AddPartner
